module.exports = __webpack_public_path__ + "static/media/CROWN-WP-3.2fc65874.jpg";